import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import parser from "html-react-parser";
import { jsonKeyMapping } from "../../Config/Constants";
import { TemplateObject } from "../../Models/TemplateObject";
import { removeSemicolons } from "../../Util/TextUtils";

type Props = {
  labelClass: string;
  tooltipClass: string;
  formElement: TemplateObject;
};

const ToolTipWithLabelComponent = ({
  labelClass,
  tooltipClass,
  formElement,
}: Props) => {
  const [show, setShow] = useState(true);
  const tooltipId = `button-tooltip-${formElement[jsonKeyMapping.FORM_ID]}`;
  
  // Remove semicolons from label text
  const rawLabelText = formElement[jsonKeyMapping.FORM_LABEL_SUB] ||
    formElement[jsonKeyMapping.FORM_LABEL] ||
    "";
  const labelText = removeSemicolons(rawLabelText);
  
  // Remove semicolons from main label text
  const mainLabelText = removeSemicolons(formElement[jsonKeyMapping.FORM_LABEL]);

  return (
    <>
      <label className={`label-tooltip-flex ${labelClass || ""}`}>
        {labelText}
        <span
          className="tooltip-qus"
          data-tip=""
          data-for={tooltipId}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => {
            setShow(false);
            setTimeout(() => setShow(true), 50);
          }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="24"
              height="24"
              rx="12"
              stroke="#E7F1FF"
            />
            <path
              d="M10.6746 16.4062H14.3253M12.5 5.46875V6.25M17.4718 7.52816L16.9194 8.08058M19.5312 12.5H18.75M6.25 12.5H5.46875M8.08054 8.08058L7.52811 7.52816M9.73782 15.2622C8.21234 13.7367 8.21234 11.2634 9.73782 9.73788C11.2633 8.2124 13.7366 8.2124 15.2621 9.73788C16.7876 11.2634 16.7876 13.7367 15.2621 15.2622L14.8347 15.6896C14.3402 16.184 14.0625 16.8546 14.0625 17.5539V17.9688C14.0625 18.8317 13.3629 19.5313 12.5 19.5312C11.637 19.5313 10.9375 18.8317 10.9375 17.9688V17.5539C10.9375 16.8546 10.6597 16.184 10.1652 15.6896L9.73782 15.2622Z"
              stroke="#0E77FF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </label>

      {show && (
        <ReactTooltip
          id={tooltipId}
          effect="float"
          multiline
          clickable
          offset={{ right: 5 }}
          className="tooltip-max-width"
        >
          {parser(formElement[jsonKeyMapping.FORM_SUB_TOOLTIP]) || ""}
        </ReactTooltip>
      )}

      <div>
        {formElement[jsonKeyMapping.FORM_LABEL_SUB] && (
          <label className={`d-inline ${labelClass || ""}`}>
            {mainLabelText}
          </label>
        )}
        {formElement[jsonKeyMapping.FORM_SUBTEXT] && (
          <small className="form-text text-muted subtext d-md-block">
            {formElement[jsonKeyMapping.FORM_SUBTEXT] || ""}
          </small>
        )}
      </div>
    </>
  );
};

export default ToolTipWithLabelComponent;
